<template>
  <div class="h-screen w-screen tracking-wider bg-black">
    <div class="relative bg-black">
      <img src="../assets/bar2.png" alt="editor" class="w-full opacity-50" />
      <div class="absolute"></div>
    </div>
    <div
      class="pb-48 text-center bg-gray-900 flex justify-center items-center w-full"
    >
      <div class="pt-24">
        <h1 class="text-4xl text-teal-400 tracking-widest font-extrabold">
          <span class="block"> Templyfy </span>
          <span
            class="text-xs -mt-1 font-normal text-white tracking-normal block"
            >Tailwind editor</span
          >
        </h1>
        <p class="text-red-100 flex mt-3 items-center justify-center">
          <span>Create your </span>
          <img
            title="templyfy tailwind editor react component"
            src="../assets/react.webp"
            class="h-4 ml-2 mr-1"
            alt="react logo"
          />
          <span>React</span>
          <img
            title="templyfy tailwind editor vue comoponent"
            src="../assets/logo.png"
            class="h-4 ml-2 mr-1"
            alt="react logo"
          />
          <span>Vue</span>
          <img
            title="templyfy tailwind editor angular comoponent"
            src="../assets/angular.png"
            class="h-4 ml-2 mr-1"
            alt="react logo"
          />
          <span>Angular </span>
          <span class="ml-2"> components just by some clicks.! </span>
        </p>
        <h2 class="text-blue-300 flex items-center justify-center">
          <span>A better way to create templates with</span>
          <img
            title="templyfy tailwind editor tailwind logo"
            src="../assets/tailwind.png"
            alt="tailwind logo"
            class="h-3 inline-block mx-2"
          />
          <span>Tailwind editor</span>
        </h2>
        <div class="p-16 text-center">
          <router-link
            class="bg-teal-600 text-white py-2 px-8 shadow rounded"
            to="create"
            tag="button"
          >
            Get Started
          </router-link>
        </div>
      </div>
    </div>
    <div class="p-2 bg-gray-900 text-right text-xs px-8 text-gray-600 flex justify-between">
      <div class="text-gray-800">v1.1</div>
      <div>© 2021 mkashif</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex";

export default {
  name: "Landing",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
